import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const propertyContactHistory = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.PROPERTY_CONTACT_REQUEST:
      draft.loading = true;
      return draft;
    case ACTIONS.PROPERTY_CONTACT_SUGGESTION_REQUEST:
      draft.suggestionLoading = true;
      return draft;
    case ACTIONS.PROPERTY_CONTACT_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.value = action.response;
      return draft;
    case ACTIONS.PROPERTY_CONTACT_SUGGESTION_SUCCESS:
      draft.suggestionLoading = false;
      draft.error = null;
      return draft;
    case ACTIONS.PROPERTY_CONTACT_LIST_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.list = action.response.list;
      draft.pagination = action.response.pagination;
      return draft;
    case ACTIONS.PROPERTY_CONTACT_ERROR:
      draft.loading = false;
      draft.error = action.error;
      return draft;
    case ACTIONS.PROPERTY_CONTACT_SUGGESTION_ERROR:
      draft.suggestionLoading = false;
      draft.error = action.error;
      return draft;
    default:
      return draft;
  }
});

export default propertyContactHistory;
